module.exports = __webpack_public_path__ + "img/13.c62a8f57.png";